import { Link } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import HomeMedicalBox from "../HomeLogged/HomeMedicalBox";
import useStyles from "../../assets/styles/styles";

const MedicalSection = ({ 
    title, 
    linkTo, 
    titleClass, 
    titleContainerClass = "homeBoxTitleMedicalProfile",
    linkClass,
    contentClass = "listCommunicationsMedicalProfile",
    children 
}) => {
    const classes = useStyles();

    return (
        <HomeMedicalBox>
            <Box className={`${classes[titleContainerClass]}`}>
                <Typography className={`${classes[titleClass]}`}>
                    {title}
                </Typography>
                <Typography 
                    component={Link} 
                    to={linkTo} 
                    className={`${classes[linkClass]}`}
                >
                    <ArrowForwardIosIcon className={`${classes.iconArrowHomeProfileMedical}`}/>
                </Typography>
            </Box>
            <Box className={`${classes[contentClass]}`}>
                {children}
            </Box>
        </HomeMedicalBox>
    );
};

export default MedicalSection;